export const i18nSliceName = "i18n";

export const i18nInitState = {
  language: {},
  languages: [],
  phrases: {},
};
